import BossModel from "@/models/BossModel";
import Agent from '@/models/Agent/Agent';

export default class BusinessHour extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'agent/business-hour';

    /**
     *
     * @type {string}
     */
    static entity = 'agentBusinessHours';

    static fields() {
		return {
            id: this.number(null),
            agent_id: this.number(null),
            day_of_week: this.number(null),
            start_hour: this.attr(null),
            end_hour: this.attr(null),
            nl_start_hour: this.attr(null),
            nl_end_hour: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            agent: this.belongsTo(Agent, 'agent_id'),
        }
	}

    /**
     *
     * @returns {boolean|*}
     */
    Agent() {
        return this.getRelated('agent');
    }

    static dayOfWeekAsString(dayIndex) {
        return ["Maandag","Dinsdag","Woensdag","Donderdag","Vrijdag","Zaterdag","Zondag"][dayIndex-1] || '';
    }


}
